<header class="topnav">
    <nav class="navbar navbar-expand-lg">
        <nav class="container-fluid">
            <app-menu-navbar/>
        </nav>
    </nav>
</header>
